import { $api } from "../generated/client";

export const useFrontChatHash = () => {
  return $api.useQuery("get", "/auth/frontchat-hash");
};
